export const config ={
   api_path:`${process.env.REACT_APP_BASE_URL}/api/v1/backoffice`,
}
